module.exports = {
  // EndPoint: "http://localhost:20001",
  // EndPoint: "https://backend.payfren.id/dev",
  // ApiSunrise: "https://mon-backend.payfren.id.id/dev",

  EndPoint: "https://rainbow.payfren.id",
  ApiFren: "https://sunrise.payfren.id",
  PayFren: "https://payfren.id",
  Resource: "https://resource.payfren.id/",

  // EndPoint: "https://backend.payfren.id",
  // ApiSunrise: "https://mon-backend.payfren.id",
  // Resource: "https://resource.payfren.id/",
};
